const xAlert$2 = {
  actions: {
    close: "Clique aqui para fechar o alerta."
  }
};
const XBreadCrumb$2 = {
  actions: {
    openMenu: "Clique aqui para visualizar todos os links."
  }
};
const xCollapse$2 = {
  actions: {
    close: "Clique aqui para ocultar as informações.",
    open: "Clique aqui para exibir as informações."
  }
};
const XFileInput$2 = {
  placeholder: "Selecionar arquivo"
};
const xInlineEdit$2 = {
  actions: {
    edit: {
      title: "Clique aqui para editar {label}"
    },
    cancel: {
      title: "Clique aqui para cancelar a edição {label}"
    },
    save: {
      title: "Clique aqui para salvar a edição {label}"
    }
  }
};
const xModal$2 = {
  actions: {
    close: "Clique aqui para fechar o modal."
  }
};
const xPagination$2 = {
  aria: {
    label: "Páginas para navegação."
  },
  next: "Ir para próxima página.",
  prev: "Ir para página anterior."
};
const xSelect$2 = {
  actions: {
    select: {
      ellipsis: "Selecione...",
      all: "Selecionar todos"
    },
    search: "Buscar"
  },
  searchEmpty: "Nenhum resultado encontrado."
};
const xSpinner$2 = {
  loading: "Carregando..."
};
const xTooltip$2 = {
  actions: {
    close: "Clique aqui para fechar."
  }
};
const validations$2 = {
  errors: {
    required: "O campo é obrigatório",
    phone: "Digite um telefone válido",
    email: "Informe um e-mail válido",
    cnpj: "Informe um CNPJ válido",
    cpf: "Informe um CPF válido",
    document: "Informe um documento válido",
    date: "Informe uma data válida",
    fullName: "Utilize nome e sobrenome",
    dateInThePast: "Deve ser anterior à data atual"
  }
};
const datetimeFormats$3 = {
  shortNumeric: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  short: {
    year: "numeric",
    month: "short",
    day: "numeric"
  }
};
const global$2 = {
  actions: {
    edit: {
      base: "Editar"
    },
    cancel: {
      base: "Cancelar"
    },
    save: {
      base: "Salvar"
    }
  },
  badge: {
    new: "Novo",
    beta: "Beta"
  }
};
const numberFormats$3 = {
  currency: {
    style: "currency",
    currency: "BRL",
    notation: "standard"
  },
  decimal: {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
};
const ptBr = {
  messages: {
    ds: {
      xAlert: xAlert$2,
      XBreadCrumb: XBreadCrumb$2,
      xCollapse: xCollapse$2,
      XFileInput: XFileInput$2,
      xInlineEdit: xInlineEdit$2,
      xModal: xModal$2,
      xPagination: xPagination$2,
      xSelect: xSelect$2,
      xSpinner: xSpinner$2,
      xTooltip: xTooltip$2,
      validations: validations$2,
      global: global$2
    }
  },
  datetimeFormats: datetimeFormats$3,
  numberFormats: numberFormats$3
};
const xAlert$1 = {
  actions: {
    close: "Click here to close the alert."
  }
};
const XBreadCrumb$1 = {
  actions: {
    openMenu: "Click here to see all links."
  }
};
const xCollapse$1 = {
  actions: {
    close: "Click here to hide the information.",
    open: "Click here to show the information."
  }
};
const XFileInput$1 = {
  placeholder: "Select file"
};
const xInlineEdit$1 = {
  actions: {
    edit: {
      title: "Click here to edit {label}"
    },
    cancel: {
      title: "Click here to cancel the edit {label}"
    },
    save: {
      title: "Click here to save the edit {label}"
    }
  }
};
const xModal$1 = {
  actions: {
    close: "Click here to close the modal."
  }
};
const xPagination$1 = {
  aria: {
    label: "Navigation pages."
  },
  next: "Go to next page.",
  prev: "Go to previous page."
};
const xSelect$1 = {
  actions: {
    select: {
      ellipsis: "Select...",
      all: "Select all"
    },
    search: "Search"
  },
  searchEmpty: "No results found."
};
const xSpinner$1 = {
  loading: "Loading..."
};
const xTooltip$1 = {
  actions: {
    close: "Click here to close."
  }
};
const validations$1 = {
  errors: {
    required: "This field is required",
    phone: "Enter a valid phone number",
    email: "Enter a valid email address",
    cnpj: "Enter a valid CNPJ",
    cpf: "Enter a valid CPF",
    document: "Enter a valid document",
    date: "Enter a valid date",
    fullName: "Use both first and last names",
    dateInThePast: "Must be before the current date"
  }
};
const datetimeFormats$2 = {
  shortNumeric: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  short: {
    year: "numeric",
    month: "short",
    day: "numeric"
  }
};
const global$1 = {
  actions: {
    edit: {
      base: "Edit"
    },
    cancel: {
      base: "Cancel"
    },
    save: {
      base: "Save"
    }
  },
  badge: {
    new: "New",
    beta: "Beta"
  }
};
const numberFormats$2 = {
  currency: {
    style: "currency",
    currency: "USD",
    notation: "standard"
  },
  decimal: {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
};
const enUs = {
  messages: {
    ds: {
      xAlert: xAlert$1,
      XBreadCrumb: XBreadCrumb$1,
      xCollapse: xCollapse$1,
      XFileInput: XFileInput$1,
      xInlineEdit: xInlineEdit$1,
      xModal: xModal$1,
      xPagination: xPagination$1,
      xSelect: xSelect$1,
      xSpinner: xSpinner$1,
      xTooltip: xTooltip$1,
      validations: validations$1,
      global: global$1
    }
  },
  datetimeFormats: datetimeFormats$2,
  numberFormats: numberFormats$2
};
const xAlert = {
  actions: {
    close: "Haz click aquí para cerrar la alerta."
  }
};
const XBreadCrumb = {
  actions: {
    openMenu: "Haz click aquí para ver todos los enlaces."
  }
};
const xCollapse = {
  actions: {
    close: "Haz click aquí para ocultar la información.",
    open: "Haz click aquí para mostrar la información."
  }
};
const XFileInput = {
  placeholder: "Seleccionar archivo"
};
const xInlineEdit = {
  actions: {
    edit: {
      title: "Haz click aquí para editar {label}"
    },
    cancel: {
      title: "Haz click aquí para cancelar la edición de {label}"
    },
    save: {
      title: "Haz click aquí para guardar la edición de {label}"
    }
  }
};
const xModal = {
  actions: {
    close: "Haz click aquí para cerrar la ventana."
  }
};
const xPagination = {
  aria: {
    label: "Páginas para navegación web."
  },
  next: "Ir a la siguiente página.",
  prev: "Ir a la página anterior."
};
const xSelect = {
  actions: {
    select: {
      ellipsis: "Seleccionar...",
      all: "Seleccionar todos"
    },
    search: "Buscar"
  },
  searchEmpty: "No se encontraron resultados."
};
const xSpinner = {
  loading: "Cargando..."
};
const xTooltip = {
  actions: {
    close: "Haz click aquí para cerrar."
  }
};
const validations = {
  errors: {
    required: "El campo es obligatorio",
    phone: "Ingresa un teléfono válido",
    email: "Ingresa un correo electrónico válido",
    cnpj: "Ingresa un CNPJ válido",
    cpf: "Ingresa un CPF válido",
    document: "Ingresa un documento válido",
    date: "Ingresa una fecha válida",
    fullName: "Utiliza nombre y apellido",
    dateInThePast: "Debe ser anterior a la fecha actual"
  }
};
const datetimeFormats$1 = {
  shortNumeric: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  short: {
    year: "numeric",
    month: "short",
    day: "numeric"
  }
};
const global = {
  actions: {
    edit: {
      base: "Editar"
    },
    cancel: {
      base: "Cancelar"
    },
    save: {
      base: "Guardar"
    }
  },
  badge: {
    new: "Nuevo",
    beta: "Beta"
  }
};
const numberFormats$1 = {
  currency: {
    style: "currency",
    currency: "MXN",
    notation: "standard"
  },
  decimal: {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
};
const esMx = {
  messages: {
    ds: {
      xAlert,
      XBreadCrumb,
      xCollapse,
      XFileInput,
      xInlineEdit,
      xModal,
      xPagination,
      xSelect,
      xSpinner,
      xTooltip,
      validations,
      global
    }
  },
  datetimeFormats: datetimeFormats$1,
  numberFormats: numberFormats$1
};
const messages = {
  "pt-BR": ptBr.messages,
  "en-US": enUs.messages,
  "es-MX": esMx.messages
};
const datetimeFormats = {
  "pt-BR": ptBr.datetimeFormats,
  "en-US": enUs.datetimeFormats,
  "es-MX": esMx.datetimeFormats
};
const numberFormats = {
  "pt-BR": ptBr.numberFormats,
  "en-US": enUs.numberFormats,
  "es-MX": esMx.numberFormats
};
export {
  datetimeFormats,
  messages as default,
  numberFormats
};
